// src/routes/superAdminRoutes.tsx
import { lazy, Suspense } from "react";
import Loader from "../components/CustomLoader";
import { SuperAdminLayout } from "../layouts";
import { RouteObject } from "react-router-dom";

const SuperAdminDashboard = lazy(() => import("../pages/SuperAdmin/Dashboard"));
const AddTenant = lazy(() => import("../pages/SuperAdmin/AddTenant"));
const TenantList = lazy(() => import("../pages/SuperAdmin/TenantList"));
const TenantPlanHistory = lazy(() => import("../pages/SuperAdmin/TenantPlanHistory"));
const Settings = lazy(() => import("../pages/SuperAdmin/Settings"));
const SubscriptionList = lazy(() => import("../pages/SuperAdmin/SubscriptionList"));
const AddSubscription = lazy(() => import("../pages/SuperAdmin/AddSubscription"));
const ActiveSubscriptions = lazy(() => import("../pages/SuperAdmin/ActiveSubscriptions"));
const ActiveSubscriptionInvoices = lazy(() => import("../pages/SuperAdmin/ActiveSubscriptionInvoices"));
const AddEditCustomField = lazy(() => import("../pages/SuperAdmin/TenantCustomFields/AddEditCustomField"));
const ConnectedTenentWhatsapp = lazy(() => import("../pages/SuperAdmin/Whatsapp/ConnectedTenentWhatsapp"));
const ConnectWhatsAppForTenent = lazy(() => import("../pages/SuperAdmin/Whatsapp/ConnectWhatsAppForTenent"));
const AvailableWhatsappTempelate = lazy(() => import("../pages/SuperVisor/Whatsapp/AvailableWhatsappTempelate"));
const EditWhatsappTempelate = lazy(() => import("../pages/SuperAdmin/Whatsapp/EditwhatsAppTempelate"));
const ConnectedTenentFacebook = lazy(() => import("../pages/SuperAdmin/Facebook/ConnectedTenentFacebook"));
const ConnectTenetFacebook = lazy(() => import("../pages/SuperAdmin/Facebook/ConnectTenetFacebook"));
const EditFacebookForTenent = lazy(() => import("../pages/SuperAdmin/Facebook/EditFacebookForTenent"));
const SuperAdminProfile = lazy(() => import("../pages/SuperAdmin/Profile"));
const RetentionDefaultPolicies = lazy(() => import("../pages/SuperAdmin/Retention/RetentionDefaultPolicies"));



const withSuspense = (Component: React.FC) => (
  <Suspense fallback={<Loader force={true} />}>
    <Component />
  </Suspense>
);


export const superAdminRoutes: RouteObject[] = [
  {
    path: "/",
    element: <SuperAdminLayout />,
    children: [
      { path: "", element: withSuspense(SuperAdminDashboard) },
      { path: "dashboard", element: withSuspense(SuperAdminDashboard) },

      { path: "tenants", element: withSuspense(TenantList) },
      { path: "tenants/add", element: withSuspense(AddTenant) },
      { path: "tenants/:id", element: withSuspense(AddTenant) },
      { path: "tenants/:tenantId/plan-history", element: withSuspense(TenantPlanHistory) },

      { path: "retention-policies", element: withSuspense(RetentionDefaultPolicies) },

      // Custom Field Management Routes
      { path: "tenants/:tenantId/custom-fields/add", element: withSuspense(AddEditCustomField) },
      { path: "tenants/:tenantId/custom-fields/edit/:fieldId", element: withSuspense(AddEditCustomField) },

      { path: "settings/whatsapp", element: withSuspense(ConnectedTenentWhatsapp) },
      { path: "settings/whatsapp/template", element: withSuspense(AvailableWhatsappTempelate) },
      { path: "settings/whatsapp/tenant", element: withSuspense(ConnectWhatsAppForTenent) },
      { path: "settings/whatsapp/template/edit", element: withSuspense(EditWhatsappTempelate) },

      { path: "settings/facebook", element: withSuspense(ConnectedTenentFacebook) },
      { path: "settings/facebook/tenant", element: withSuspense(ConnectTenetFacebook) },
      { path: "settings/facebook/tenant/edit/:id", element: withSuspense(EditFacebookForTenent) },

      { path: "subscription", element: withSuspense(SubscriptionList) },
      { path: "active-subscriptions", element: withSuspense(ActiveSubscriptions) },
      { path: "active-subscriptions/:userId/invoices", element: withSuspense(ActiveSubscriptionInvoices) },
      { path: "subscription/add", element: withSuspense(AddSubscription) },
      { path: "subscription/edit/:id", element: withSuspense(AddSubscription) },


      { path: "settings/vici-dialer-process", element: withSuspense(Settings) },

      { path: "profile", element: withSuspense(SuperAdminProfile) }
    ],
  },
];
